<template>
  <div>
    <el-page-header @back="goBack" content=""></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">

        <div class="pub-line">
          <span>名称：</span>
          <span class="glay"
          >{{ appInfo.appName }}({{ appInfo.appTypeName }})</span
          >
        </div>

        <div class="pub-line">
          <span>应用ID：</span>
          <span class="glay">{{ appInfo.appid }}</span>
        </div>

        <div style="margin-top: 30px">
          <span>渠道：</span>
          <span>
            <el-tag
                :class="{ 'tag-marr': true, activeBg: tagIndex == index }"
                v-for="(item, index) in getChannel"
                :key="index"
                style="margin-bottom: 10px"
                @click="activeEvent(index, item.channelAccountId)"
                effect="plain"
            >[{{ item.channelTypeName }}] - {{ item.account }} -（ {{ item.code }} ）</el-tag
            >
          </span>
        </div>

        <div style="margin-top: 30px">
          <span>业务：</span>
          <span class="in_tabs" @click="changActive(index)" :class="{'active_in_tab':index==businessIndex}"
                v-for="(item,index) in businessList" :key="index">{{ item.name }}</span>
        </div>

        <div v-if="businessIndex==0" style="margin-top: 30px">
          <span>导航：</span>
          <span>
            <el-tag
                :class="{ 'tag-marr': true, 'active-bg1': navIndex == index }"
                v-for="(item, index) in getNav"
                :key="index"
                @click="activeEventNav(index, item.appNavId)"
                effect="plain"
                type="danger"
            >{{ item.name }}</el-tag
            >
          </span>
        </div>

        <div v-if="businessIndex==1" style="margin-top: 30px">
          <span>导航：</span>
          <span class="in_tabs_car" @click="changTarotCategoryId(item)"
                :class="{'active_in_tab_car':item.tarotCategoryId==tarotCategoryId}"
                v-for="(item,index) in tarotCategoryList" :key="index">{{ item.name }}</span>
        </div>

        <div v-if="businessIndex==2" style="margin-top: 30px">
          <span>导航：</span>
          <span class="in_tabs_car" @click="changLiteratureType(item)"
                :class="{'active_in_tab_car':item.type==intitleType}"
                v-for="(item,index) in literatureTypelist" :key="index">{{ item.name }}</span>
        </div>

        <div style="margin-top: 30px" v-if="businessIndex==0">
          <el-button
              type="primary"
              plain
              size="medium"
              @click="handleselectTopic"
              :disabled="isEmpty(getChannel) || isEmpty(getNav) ? true : false"
          >选择测评题
          </el-button
          >
        </div>

        <div style="margin-top: 30px" v-if="businessIndex==1">
          <el-button
              type="primary"
              plain
              size="medium"
              @click="handleselectTarot"
          >选择塔罗
          </el-button
          >
        </div>

        <div style="margin-top: 30px" v-if="businessIndex==2">
          <el-button
              type="primary"
              plain
              size="medium"
              @click="getLiteratureData"
          >选择国学
          </el-button
          >
        </div>

        <div v-if="businessIndex==0" style="margin-top: 30px">
          <div class="public-table-data">
            <el-table
                ref="multipleTable"
                size="mini"
                :data="tableData"
                border
                style="width: 100%"
                row-key="menuId"
                v-loading="loading"
            >
              >
              <el-table-column
                  type="index"
                  label="序号"
                  width="80"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="名称"
                  width="180"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="examId"
                  label="标识"
                  width="150"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="categoryName"
                  label="分类"
                  width="150"
                  align="center"
              >
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.categoryName1 }}-{{ scope.row.categoryName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="categoryName"
                  label="题目"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <div>维度：{{ scope.row.dimensions }}</div>
                  <div>基准：{{ scope.row.datums }}</div>
                  <div>题目：{{ scope.row.questions }}</div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="showAnswers"
                  label="参与数"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      placeholder="输入参与数"
                      v-model="scope.row.showAnswers"
                      style="width: 70px"
                      @blur="answeNum(scope.row.showAnswers, scope.row.appExamId)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  prop="showBuys"
                  label="购买数"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      placeholder="输入购买数"
                      v-model="scope.row.showBuys"
                      style="width: 70px"
                      @blur="buyNum(scope.row.showBuys, scope.row.appExamId)"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column
                  prop="payPrice"
                  label="支付价"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      placeholder="输入支付价"
                      v-model="scope.row.payPrice"
                      style="width: 70px"
                      @blur="payPrice(scope.row.payPrice, scope.row.appExamId)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  prop="payPrice"
                  label="原价"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      placeholder=""
                      v-model="scope.row.rawPrice"
                      style="width: 70px"
                      @blur="
                      originalPayPrice(scope.row.rawPrice, scope.row.appExamId)
                    "
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column
                  prop="status"
                  label="发布"
                  width="70"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-switch
                      v-model="scope.row.status"
                      :active-value="1"
                      :inactive-value="0"
                      @change="changeSwitchIssue(scope.row.appExamId)"
                  >
                  </el-switch>
                </template>
              </el-table-column>

              <el-table-column
                  prop="istop"
                  label="推荐"
                  width="70"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-switch
                      v-model="scope.row.istop"
                      :active-value="1"
                      :inactive-value="0"
                      @change="changeSwitchReco(scope.row.appExamId)"
                  >
                  </el-switch>
                </template>
              </el-table-column>

              <el-table-column
                  prop="issuedTime"
                  label="上架时间"
                  width="150"
                  align="center"
              >
              </el-table-column>

              <el-table-column
                  label="操作"
                  align="center"
                  min-width="520"
                  fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      @click="handleVoucherClick(scope.row)"
                      type="success"
                      style="margin-bottom: 5px"
                      plain
                  >绑定券事件
                  </el-button
                  >
                  <el-button
                      size="mini"
                      @click="handleClick('edit', scope.row)"
                      type="success"
                      style="margin-bottom: 5px"
                      plain
                  >编辑
                  </el-button
                  >
                  <el-button
                      size="mini"
                      @click="handleClick('recommend', scope.row)"
                      type="warning"
                      plain
                  >推荐
                  </el-button
                  >
                  <el-button
                      size="mini"
                      @click="handleClick('link', scope.row)"
                      type="warning"
                      plain
                  >推广链接
                  </el-button
                  >
                  <el-button
                      size="mini"
                      @click="handleSchemeClick(scope.row)"
                      type="warning"
                      plain
                  >方案组绑定
                  </el-button
                  >
                  <!--                  <el-button-->
                  <!--                      size="mini"-->
                  <!--                      @click="handleClick('time', scope.row)"-->
                  <!--                      type="warning"-->
                  <!--                      plain-->
                  <!--                  >刷新上架时间-->
                  <!--                  </el-button-->
                  <!--                  >-->
                  <el-button
                      size="mini"
                      @click="handleClick('del', scope.row)"
                      type="warning"
                      plain
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-if="businessIndex==1" style="margin-top: 30px">
          <div class="public-table-data">
            <el-table
                ref="multipleTable"
                size="mini"
                :data="tarotPriceList"
                border
                style="width: 100%"
                row-key="menuId"
                v-loading="loading"
            >
              >
              <el-table-column
                  type="index"
                  label="序号"
                  width="80"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="名称"
                  width="180"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="code"
                  label="标识"
                  width="150"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="tarotCategoryName"
                  label="分类"
                  width="150"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="favorable"
                  label="好评率/%"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      placeholder="输入好评率"
                      v-model="scope.row.favorable"
                      style="width: 70px"
                      @blur="changInfoTag(5,scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  prop="submits"
                  label="参与数"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      placeholder="输入参与数"
                      v-model="scope.row.submits"
                      style="width: 70px"
                      @blur="changInfoTag(1,scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  prop="showBuys"
                  label="购买数"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      placeholder="输入购买数"
                      v-model="scope.row.buys"
                      style="width: 70px"
                      @blur="changInfoTag(2,scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  prop="payPrice"
                  label="支付价"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      placeholder="输入支付价"
                      v-model="scope.row.payPrice"
                      style="width: 70px"
                      @blur="changInfoTag(3,scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  prop="payPrice"
                  label="原价"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      placeholder=""
                      v-model="scope.row.rawPrice"
                      style="width: 70px"
                      @blur="changInfoTag(4,scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  prop="status"
                  label="发布"
                  width="70"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-switch
                      :value="scope.row.status"
                      :active-value="1"
                      :inactive-value="0"
                      @change="changeSwitchTab(1,scope.row)"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column
                  prop="shows"
                  label="推荐"
                  width="70"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-switch
                      :value="scope.row.shows"
                      :active-value="1"
                      :inactive-value="0"
                      @change="changeSwitchTab(2,scope.row)"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column
                  prop="utime"
                  label="上架时间"
                  width="150"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  label="操作"
                  align="center"
                  min-width="200"
                  fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      @click="getTarotExtensionLink(scope.row)"
                      type="warning"
                      plain
                  >推广链接
                  </el-button
                  >
                  <el-button
                      size="mini"
                      @click="handleDelect(scope.row)"
                      type="warning"
                      plain
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-if="businessIndex==2" style="margin-top: 30px">
          <div class="public-table-data">
            <el-table
                ref="multipleTable"
                size="mini"
                :data="literatureList"
                border
                style="width: 100%"
                row-key="menuId"
                v-loading="loading"
            >
              >
              <el-table-column
                  type="index"
                  label="序号"
                  width="80"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="名称"
                  width="180"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="intitleId"
                  label="标识"
                  width="150"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="submits"
                  label="参与数"
                  width="140"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      placeholder="输入参与数"
                      v-model="scope.row.submits"
                      style="width: 100px"
                      @blur="changInfoTagLiterature(1,scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  prop="showBuys"
                  label="购买数"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      placeholder="输入购买数"
                      v-model="scope.row.buys"
                      style="width: 70px"
                      @blur="changInfoTagLiterature(2,scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  prop="payPrice"
                  label="支付价"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      placeholder="输入支付价"
                      v-model="scope.row.payPrice"
                      style="width: 70px"
                      @blur="changInfoTagLiterature(3,scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  prop="payPrice"
                  label="原价"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-input
                      type="text"
                      placeholder=""
                      v-model="scope.row.rawPrice"
                      style="width: 70px"
                      @blur="changInfoTagLiterature(4,scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  prop="status"
                  label="发布"
                  width="70"
                  align="center"
              >
                <template slot-scope="scope">
                  <el-switch
                      :value="scope.row.status"
                      :active-value="1"
                      :inactive-value="0"
                      @change="changeLiteratureSwitchTab(1,scope.row)"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column
                  prop="utime"
                  label="上架时间"
                  width="150"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  label="操作"
                  align="center"
                  min-width="260"
                  fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      @click="getShowGouxue(scope.row)"
                      type="warning"
                      plain
                  >编辑
                  </el-button
                  >
                  <el-button
                      size="mini"
                      @click="getLiteratureExtensionLink(scope.row)"
                      type="warning"
                      plain
                  >推广链接
                  </el-button
                  >
                  <el-button
                      size="mini"
                      @click="handleLiteratureDelect(scope.row)"
                      type="warning"
                      plain
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 选择国学内容-->
    <el-dialog
        width="747px"
        title="选择测评题"
        :visible.sync="literatureVisible"
        append-to-body
        :close-on-click-modal="false"

    >
      <div class="public-table-data">
        <el-table
            ref="multipleTable"
            size="mini"
            :data="literatureData"
            border
            style="width:100%"
            row-key="menuId"
            v-loading="loading"
            @selection-change="handleLiteratureSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="序号" width="80" align="center">
          </el-table-column>
          <el-table-column prop="name" label="名称" width="180" align="center">
          </el-table-column>
          <el-table-column prop="intitleId" label="标识" width="150" align="center">
          </el-table-column>
          <el-table-column
              prop="categoryName"
              label="数据"
              width="120"
              align="center"
          >
            <template slot-scope="scope">
              <div>参与：{{ scope.row.submits }}</div>
              <div>购买：{{ scope.row.buys }}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="payPrice"
              label="支付价"
              width="120"
              align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.payPrice !== 0
                    ? `￥${scope.row.payPrice / 100}`
                    : 0
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="literatureVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="handleSaveLiterature"
        >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 选择塔罗测算内容-->
    <el-dialog
        width="826px"
        title="选择塔罗"
        :visible.sync="tarotVisible"
        append-to-body
        :close-on-click-modal="false"
    >
      <div class="public-table-data">
        <el-table
            ref="multipleTable"
            size="mini"
            :data="tarotTypelist"
            border
            style="width:100%"
            row-key="menuId"
            v-loading="loading"
            @selection-change="handleTarotSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="序号" width="80" align="center">
          </el-table-column>
          <el-table-column prop="name" label="名称" width="180" align="center">
          </el-table-column>
          <el-table-column prop="code" label="标识" width="80" align="center">
          </el-table-column>
          <el-table-column prop="tarotCategoryName" label="类型" width="150" align="center">
          </el-table-column>
          <el-table-column
              prop="categoryName"
              label="数据"
              width="120"
              align="center"
          >
            <template slot-scope="scope">
              <div>参与：{{ scope.row.submits }}</div>
              <div>购买：{{ scope.row.buys }}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="payPrice"
              label="支付价"
              width="120"
              align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.payPrice !== 0
                    ? `￥${scope.row.payPrice / 100}`
                    : 0
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="tarotVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="handleSaveTarot"
        >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 选择测评题 -->
    <el-dialog
        width="1195px"
        title="选择测评题"
        :visible.sync="innerVisible"
        append-to-body
        :close-on-click-modal="false"
    >
      <selectTopic @childByValue="childByValue"/>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="innerVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="handleTopicList"
        >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑评测题信息"
        :visible.sync="dialogVisible"
        width="660px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-form-item prop="paymentType" label="分类">
            {{ params.categoryName1 }}- {{ params.categoryName }}
          </el-form-item>

          <el-form-item label="列表图" prop="logo">
            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy"
                  />
                </span>
                <div
                    class="up-btn"
                    style="width: 75px; height: 75px; line-height: 80px"
                    @click="getPolicy"
                    v-if="isMoer"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="file"
                  @change="getFile"
                  accept="image/png,image/jpg"
              />
            </div>

            <div class="diplay" style="margin-right: 50px">
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcListLang"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 150px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicyLang"
                  />
                </span>
                <div
                    class="up-btn"
                    style="width: 150px; height: 75px; line-height: 80px"
                    @click="getPolicyLang"
                    v-if="isMoerLang"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="fileLang"
                  @change="getFileLang"
                  accept="image/png,image/jpg"
              />
            </div>

            <div class="diplay">
              <span class="video-label">视频</span>
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcListVideo"
                    :key="index"
                    class="slideshow"
                >
                  <div @click="getPolicyVideo">
                    <video
                        width="100%"
                        controls="controls"
                        style="width: 75px; height: 75px; border-radius: 6px"
                    >
                      <source :src="srcListVideo" type="video/mp4"/>
                    </video>
                  </div>
                </span>
                <div
                    class="up-btn"
                    style="width: 75px; height: 75px; line-height: 80px"
                    @click="getPolicyVideo"
                    v-if="isMoerVideo"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="fileVideo"
                  @change="getFileVideo"
                  accept="video/*"
              />
            </div>
          </el-form-item>

          <el-form-item label="轮播图">
            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcListBanner"
                    :key="index"
                    class="slideshow"
                >
                  <div class="icon-close" @click="removeUploading(index)">
                    <i class="el-icon-close"></i>
                  </div>
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicyBanner"
                  />
                </span>
                <div
                    class="up-btn"
                    style="width: 75px; height: 75px; line-height: 80px"
                    @click="getPolicyBanner"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="fileBanner"
                  @change="getFileBanner"
                  accept="image/png,image/jpg"
              />
            </div>
          </el-form-item>

          <el-form-item label="名称" prop="name">
            <el-input
                placeholder="请填写名称"
                v-model="params.name"
                style="width: 234px"
            ></el-input>
            <span style="margin: 0 12px 0 30px">标识</span>
            <span>{{ params.examId }}</span>
          </el-form-item>
          <el-form-item label="主题" prop="subject">
            <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 4 }"
                placeholder="请填写主题"
                v-model="params.subject"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="标签" prop="pages">
            <span>{{ params.pages }}</span>
            页专业报告，约
            <span>{{ params.times }}</span>
            分钟
            <span style="margin: 0 12px 0 30px">解析</span>
            <span>{{ params.schemeName }}</span>
          </el-form-item>

          <el-form-item label="详情" prop="detail">
            <!-- <quill-editor
              ref="editorComp"
              class="ql-toolbar editor"
              v-model="params.detail"
              :options="editorOption"
              clearable
            >
            </quill-editor> -->
            <richText :keyWord="'detail'" :params="params" v-if="flag"></richText>
          </el-form-item>
          <el-row type="flex">
            <el-col>
              <el-form-item label="落地页：">
                <span style="margin-right: 15px">老样式</span>
                <el-switch
                    v-model="params.footNav"
                    :active-value="2"
                    :inactive-value="1"
                >
                </el-switch>
                <span style="margin-left: 15px">新样式</span>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="数据源：">
                <span style="margin-right: 15px">题库数据</span>
                <el-switch
                    v-model="params.dataStatus"
                    :active-value="2"
                    :inactive-value="1"
                >
                </el-switch>
                <span style="margin-left: 15px">本地数据</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <!-- 测评题推广链接 -->
    <el-dialog
        title="推广链接"
        :visible.sync="dialogVisibleLink"
        width="660px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <el-form label-width="80px" ref="linkForm">
        <el-form-item label="分类：" v-if="params.categoryName1">
          {{ params.categoryName1 }}- {{ params.categoryName }}
        </el-form-item>
        <el-form-item label="分类：" v-else-if="params.tarotCategoryName">
          {{ params.tarotCategoryName }}
        </el-form-item>
        <el-form-item label="列表图：">
          <el-image
              v-if="params.logo"
              style="
              width: 75px;
              height: 75px;
              border-radius: 6px;
              margin-right: 20px;
            "
              :src="params.logo? params.logo : '' "
              fit="cover"
          />
          <el-image
              v-if="params.logo2"
              style="width: 150px; height: 75px; border-radius: 6px"
              :src="params.logo2? params.logo2 : null "
              fit="cover"
          />
        </el-form-item>
        <el-form-item label=" 名称：">
          {{ params.name }}
          <span style="margin-left: 150px" v-if="businessIndex==0"> 标识：{{ params.examId }}</span>
          <span style="margin-left: 150px" v-if="businessIndex==1"> 标识：{{ params.code }}</span>
          <span style="margin-left: 150px" v-if="businessIndex==2"> 标识：{{ params.intitleId }}</span>
        </el-form-item>
        <!--        <el-form-item label=" 渠道：">-->
        <!--          {{ params.name }}-->
        <!--        </el-form-item>-->

        <el-form-item label="平台：">
          <div
              style="margin-bottom: 10px;cursor: pointer"
              v-for="(items, index) in putUpLink"
              :key="index"
              @click="copyLink(items.url)"
          >
            <el-tag type="success" size="small">{{
                items.name
              }}
            </el-tag>
            {{ items.url }}
            <el-tag size="small">复制</el-tag>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 国学编辑弹框 -->
    <el-dialog
        title="编辑国学样式信息"
        :visible.sync="guoxueDialogVisible"
        width="660px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"

            :model="guoxueParams"
            label-width="80px"
        >
          <el-form-item label="名称" prop="name">
            {{ guoxueParams.name }}
            <span style="margin: 0 12px 0 30px">标识</span>
            <span>{{ guoxueParams.intitleId }}</span>
          </el-form-item>
          <el-row>
            <el-col :span="24" style="position: relative">
              <span class="clear_icon_items postsdasinfo">*</span>
              <el-form-item label="轮播图">
                <div class="diplay" style="margin-right: 10px">
                  <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcListGuoxueBanner"
                    :key="index"
                    class="slideshow"
                >
                  <div class="icon-close" @click="removeGuxueUploading(index)">
                    <i class="el-icon-close"></i>
                  </div>
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getGuoxuePolicyBanner"
                  />
                </span>
                    <div
                        class="up-btn"
                        style="width: 75px; height: 75px; line-height: 80px"
                        @click="getGuoxuePolicyBanner"
                    >
                      <i class="el-icon-plus"></i>
                    </div>
                  </div>
                  <input
                      type="file"
                      ref="guoxuefileBanner"
                      @change="getGuoxueFileBanner"
                      accept="image/png,image/jpg"
                  />
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24" style="position: relative">
              <span class="clear_icon_items postsdas">*</span>
              <el-form-item label="详情" prop="detail">
                <richText :keyWord="'detail'" :params="guoxueParams" v-if="richTextMouted"></richText>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="guoxueDialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="guoxueHandleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <!-- 测评题推荐配置 -->
    <el-dialog
        title="推荐配置"
        :visible.sync="dialogVisibleRecommend"
        width="920px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <el-form label-width="80px" ref="linkForm">
        <el-form-item label="分类：" v-if="params.categoryName1">
          {{ params.categoryName1 }}- {{ params.categoryName }}
        </el-form-item>
        <el-form-item label="分类：" v-else-if="params.tarotCategoryName">
          {{ params.tarotCategoryName }}
        </el-form-item>
        <el-form-item label="列表图：">
          <el-image
              v-if="params.logo"
              style="
              width: 75px;
              height: 75px;
              border-radius: 6px;
              margin-right: 20px;
            "
              :src="params.logo? params.logo : '' "
              fit="cover"
          />
          <el-image
              v-if="params.logo2"
              style="width: 150px; height: 75px; border-radius: 6px"
              :src="params.logo2? params.logo2 : null "
              fit="cover"
          />
        </el-form-item>
        <el-form-item label=" 名称：">
          {{ params.name }}
          <span style="margin-left: 150px" v-if="businessIndex==0"> 标识：{{ params.examId }}</span>
          <span style="margin-left: 150px" v-if="businessIndex==1"> 标识：{{ params.code }}</span>
          <span style="margin-left: 150px" v-if="businessIndex==2"> 标识：{{ params.intitleId }}</span>
        </el-form-item>
        <div class="autos">
          <el-tabs v-model="activeName" @tab-click="handleTbaClick">
            <el-tab-pane label="底部轮播位" name="JGGG01"></el-tab-pane>
            <el-tab-pane label="底部列表位" name="JGGG02"></el-tab-pane>
          </el-tabs>
        </div>
        <el-tag style="margin-bottom: 20px;cursor: pointer" @click="bindRecommend('add')">新增推荐</el-tag>
        <el-form-item label="推荐：">
          <div class="public-table-data">
            <el-table
                ref="multipleTable"
                size="mini"
                :data="recommendSceneskDataList"
                border
                style="width:100%"
                row-key="menuId"
                v-loading="loading"
            >
              <el-table-column type="index" label="序号" width="60" align="center">
              </el-table-column>
              <el-table-column prop="recommendTypeName" label="类型" width="100" align="center">
              </el-table-column>
              <el-table-column prop="examId" label="标识" width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.examId">{{ scope.row.examId }}</span>
                  <span v-else>0</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="categoryName"
                  label="引导图"
                  width="140"
                  align="center"
              >
                <template slot-scope="scope">
                  <img :src="scope.row.recommendImg" style="width: 100px;height: auto;object-fit: cover">
                </template>
              </el-table-column>
              <el-table-column
                  prop="recommendName"
                  label="名称"
                  width="140"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  prop="seq"
                  label="排序"
                  width="80"
                  align="center"
              >
              </el-table-column>
              <el-table-column
                  label="操作"
                  align="center"
                  min-width="170"
                  fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      @click="bindRecommend('edit', scope.row)"
                      type="success"
                      style="margin-bottom: 5px"
                      plain
                  >编辑
                  </el-button
                  >
                  <el-button
                      size="mini"
                      @click="RecommendhandleClick(scope.row)"
                      type="warning"
                      plain
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 测评题推荐编辑新增 -->
    <el-dialog
        title="测评题推荐编辑新增"
        :visible.sync="dialogVisibleRecommendEvaluation"
        width="460px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <el-form label-width="80px" ref="linkForm">
        <el-form-item label="类型：">
          <el-select :disabled="RecommendclickType=='edit'" v-model="recommendParams.recommendType"
                     placeholder="请选择">
            <el-option
                label="会员" value="VIP">
            </el-option>
            <el-option
                label="测评题" value="EXAM">
            </el-option>
            <el-option
                label="书籍" value="BOOK">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" 名称：">
          <el-input v-model="recommendParams.recommendName"></el-input>
        </el-form-item>
        <el-row v-if="recommendParams.recommendType=='EXAM'">
          <el-col :span="12" v-if="RecommendclickType=='add'">
            <el-form-item class="item" label="测评题："
            >
              <div style="cursor: pointer">
                <span @click="changShowTest" v-if="recommendParams.bizName">{{ recommendParams.bizName }}</span>
                <el-tag @click="changShowTest" v-else>请选择</el-tag>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="item" label="标识："
            >{{ recommendParams.examId }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="recommendParams.recommendType=='BOOK'">
          <el-form-item label="链接：">
            <el-input v-model="recommendParams.url"></el-input>
          </el-form-item>
        </el-row>
        <el-form-item label="广告图：">
          <div class="diplay" style="margin-right: 10px">
            <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcRecommendList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getRecommendPolicy"
                  >
                  </el-image>
                </span>
              <div
                  class="up-btn"
                  style="width: 75px; height: 75px; line-height: 80px"
                  @click="getRecommendPolicy"
                  v-if="isRecommendMoer"
              >
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <input
                type="file"
                ref="recommendFile"
                @change="getRecommendFile"
                accept="image/png,image/jpg"
            />
          </div>
        </el-form-item>
        <el-form-item label=" 排序：">
          <el-input type="number" v-model="recommendParams.seq"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisibleRecommendEvaluation = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="ParmthandleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <!-- 测评题数据 -->
    <el-dialog
        title="测评题列表"
        :visible.sync="alldataSourceVisible"
        :close-on-click-modal="false"
        width="1000px"
        style="cursor: pointer"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <div style="display: flex;align-items: center;margin-bottom: 20px">
          <div class="item-son" style="margin-right: 20px">
            <el-input
                style="width: 200px"
                v-model="listParams.searchKey"
                placeholder="搜索关键词"
                clearable
                @keyup.enter.native="queryTestTableData"
            ></el-input>
          </div>
          <div class="item-son">
            <el-button type="primary" @click="queryTestTableData"
            >查询 <i class="el-icon-search"></i>
            </el-button>
          </div>
        </div>
        <div class="public-table-data" style="padding-bottom: 20px">
          <el-table
              ref="multipleTableTest"
              size="medium"
              :data="allTestTableData"
              border
              highlight-current-row
              style="width: 100%"
              v-loading="loading"
              @current-change="handExamSelectionChange"
          >
            <el-table-column type="index" label="序号" width="80" align="center">
            </el-table-column>
            <el-table-column prop="name" label="名称" align="center">
            </el-table-column>
            <el-table-column prop="examId" label="标识" width="150" align="center">
            </el-table-column>
            <el-table-column prop="descr" label="分类" width="150" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.categoryName1 }} - {{ scope.row.categoryName }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <!--券事件绑定-->
    <el-dialog
        title="编辑/新增券"
        :visible.sync="dialogVoucherVisible"
        :close-on-click-modal="false"
        width="480px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="voucherRuleForm"
            :rules="voucherRules"
            :model="voucherParams"
            label-width="100px"
        >
          <el-row>
            <el-form-item label="券事件：" prop="eventIds">
              <el-select
                  v-model="voucherParams.eventIds"
                  clearable
                  multiple
                  placeholder="请选择券事件"
                  filterable
                  style="width: 100%"
              >
                <el-option
                    v-for="(item, index) in vipRightList"
                    :key="`${index}`"
                    :label="`${item.eventName}`"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-col :span="8">
              <el-form-item label="H5启用：" prop="wechatEnable">
                <el-switch
                    v-model="voucherParams.h5Enable"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="微信启用：" prop="wechatEnable">
                <el-switch
                    v-model="voucherParams.wechatEnable"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="允许放弃：" prop="wechatEnable">
                <el-switch
                    v-model="voucherParams.giveUpEnable"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="允许返回：" prop="wechatEnable">
                <el-switch
                    v-model="voucherParams.returnEnable"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="描述：" prop="remarks">
            <el-input
                clearable
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                placeholder="请填写描述"
                v-model="voucherParams.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVoucherVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleVoucherEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <!--方案绑定-->
    <el-dialog
        title="编辑/新增方案组"
        :visible.sync="dialogSchemeVisible"
        :close-on-click-modal="false"
        width="480px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="schemeRuleForm"
            :rules="schemeRules"
            :model="schemeParams"
            label-width="80px"
        >
          <el-form-item label="方案组：" prop="skuPackageGroupId">
            <el-select
                v-model="schemeParams.skuPackageGroupId"
                clearable
                placeholder="请选择方案组"
                filterable
                style="width: 100%"
            >
              <el-option
                  v-for="(item, index) in schemeList"
                  :key="`${index}`"
                  :label="`${item.name}`"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogSchemeVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleSchemeEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import selectTopic from "./components/selectTopic.vue";
import {ossUpload} from "@utils/filters/upload";
import {isEmpty} from "../../utils/tools/index";
import richText from "../../components/richText.vue";
import {emptyShow} from "@utils/tools/index";

export default {
  components: {
    selectTopic, richText,
  },
  data() {
    return {
      flag: false, //销毁子组件
      isEmpty,
      appInfo: {},
      getChannel: [],
      getNav: [],
      tagIndex: 0,
      navIndex: 0,
      innerVisible: false,
      dialogVisible: false,
      tableData: [],
      loading: false,
      params: {},
      app: {},
      examInfoIdArr: [],
      checkArray: [], //接收选择的题目
      srcList: [],
      isMoer: true,
      srcListLang: [],
      isMoerLang: true,
      srcListVideo: "",
      isMoerVideo: true,
      srcListBanner: [],
      dialogVisibleLink: false,
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // toggled buttons
              ["blockquote", "code-block"],

              [{header: 1}, {header: 2}], // custom button values
              [{list: "ordered"}, {list: "bullet"}],
              [{script: "sub"}, {script: "super"}], // superscript/subscript
              [{indent: "-1"}, {indent: "+1"}], // outdent/indent
              [{direction: "rtl"}], // text direction

              [{size: ["small", false, "large", "huge"]}], // custom dropdown
              [{header: [1, 2, 3, 4, 5, 6, false]}],

              [{color: []}, {background: []}], // dropdown with defaults from theme
              [{font: []}],
              [{align: []}],
              ["link", "image", "video"],
              ["clean"], // remove formatting button
            ],
            handlers: {
              shadeBox: null,
              insertMetric: function () {
                //方法体
                alert(1);
              },
            },
          },
        },
      },
      rules: {
        name: [{required: true, message: "请填写名称", trigger: "change"}],
        subject: [{required: true, message: "请填写主题", trigger: "change"}],
        payPrice: [
          {required: true, message: "请填写支付价", trigger: "change"},
        ],
        pages: [{required: true, message: "请填写标签", trigger: "change"}],
        privateKey: [
          {required: true, message: "请填写商户秘钥", trigger: "change"},
        ],
        domainBizId: [
          {required: true, message: "请选择回调地址", trigger: "change"},
        ],
        domainUri: [
          {required: true, message: "请填写接口地址", trigger: "change"},
        ],
      },
      companyId: "",
      putUpLink: "", //链接
      navList: [], //已经关联的nav id
      //新改动的内容
      // 业务列表 塔罗相关
      businessList: [
        {
          name: '测算',
        },
        {
          name: '塔罗',
        },
        {
          name: '国学',
        }
      ],
      businessIndex: 0,
      tarotPriceList: [],
      tarotCategoryList: [],
      tarotCategoryId: '',
      tarotVisible: false,
      tarotTypelist: [],
      tarotMultipleSelection: [],
      //国学相关
      literatureList: [],
      literatureTypelist: [],
      literatureData: [],
      intitleType: '',
      literatureVisible: false,
      literatureMultipleSelection: [],
      // channelAccountIds:[],//已经关联的渠道 id
      //国学编辑弹框
      guoxueDialogVisible: false,
      guoxueParams: {},
      dictDataSelect1: '',
      richTextMouted: false,
      pageLoading: false,
      // guoxuerules: {
      //   name: [{required: true, message: "请填写名称", trigger: "change"}],
      // },
      guoxueSrcList: [],
      isGuoxueMoer: true,

      guoxueSrcListLang: [],
      isGuoxueMoerLang: true,

      guoxuesrcListVideo: [],
      isGuoxueMoerVideo: true,

      srcListGuoxueBanner: [],
      intitleInfoId: '',

      //推荐配置
      dialogVisibleRecommend: false,
      dialogVisibleRecommendEvaluation: false,
      recommendParams: {},
      alldataSourceVisible: false,
      listParams: {},

      allTestTableData: [],
      srcRecommendList: [],
      isRecommendMoer: true,
      recommendSceneskDataList: [],
      RecommendclickType: '',

      activeName: 'JGGG01',

      vipRightList: [],
      dialogVoucherVisible: false,
      voucherParams: {},
      voucherRules: {
        eventIds: [
          {required: true, message: "请选择关联事件", trigger: "change"},
        ],
      },
      schemeExamInfo: {},
      schemeList: [],
      dialogSchemeVisible: false,
      schemeParams: {},
      schemeRules: {
        skuPackageGroupId: [
          {required: true, message: "请选择方案组", trigger: "change"},
        ],
      },
    };
  },
  created() {
    this.getNavList(); //all anv
    this.getTarotCategoryList()
    this.getLiteratureTypeData()
    this.companyId = this.$route.query.companyId;
    this.appInfo = this.$route.query;
    this.getAreadyChannel(this.$route.query.appInfoId); //需要显示的渠道
    this.app.appInfoId = parseInt(this.$route.query.appInfoId);
    this.$nextTick(() => {
      setTimeout(() => {
        this.queryTableData()
        this.queryTestTableData()
      }, 1200);
    });
    this.getVipRightList()
  },
  watch: {
    dialogVisibleLink() {
      if (this.dialogVisibleLink == false) {
        this.params = {};
        this.srcRecommendList = []
        this.isMoer = true
      }
    },
    dialogVisibleRecommendEvaluation() {
      if (this.dialogVisibleRecommendEvaluation == false) {
        this.recommendParams = {};
        this.srcRecommendList = []
        this.isRecommendMoer = true
      }
    },
  },
  methods: {
    async handleSchemeClick(data) {
      this.schemeExamInfo = JSON.parse(JSON.stringify(data))
      this.getSchemeList(data)
      this.getBindSchemeList(data)
      this.dialogSchemeVisible = true
    },

    async getSchemeList(data) {
      const {data: resData} = await this.$get(`sku/package/group/list/${data.examId}`);
      if (resData.data) {
        this.schemeList = resData.data
      } else {
        this.schemeList = []
      }
    },

    async getBindSchemeList(data) {
      const {data: resData} = await this.$get(`/app/sku/ref/info/${data.appExamId}`);
      if (resData.data) {
        this.schemeParams = resData.data
      }else {
        this.schemeParams = {}
      }
    },

    handleSchemeEdit() {
      this.$refs.schemeRuleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          this.schemeParams.appExamId = this.schemeExamInfo.appExamId
          const {data: resData} = await this.$post(
              "/app/sku/ref/bind",
              this.schemeParams,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          this.dialogSchemeVisible = false
          this.$message.success("操作成功!");
        });
      });
    },

    async handleVoucherClick(row) {

      const {data: resData} = await this.$get(
          `app/exam/coupon/event/detail//${row.appExamId}`,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (resData.data) {
        this.voucherParams = resData.data
        let arr = []
        if (this.voucherParams.eventIds) {
          this.voucherParams.eventIds.map(item => {
            arr.push(Number(item))
          })
        }
        this.voucherParams.eventIds = arr
        this.voucherParams.appExamId = row.appExamId
      } else {
        this.voucherParams = {
          wechatEnable: 0,
          h5Enable: 0,
          appExamId: row.appExamId
        }
      }

      this.dialogVoucherVisible = true
    },
    handleVoucherEdit() {
      this.$refs.voucherRuleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {

          const {data: resData} = await this.$post(
              "/app/exam/coupon/save",
              this.voucherParams,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          // this.getVipRightList();
          this.dialogVoucherVisible = false
          this.$message.success("操作成功!");
        });
      });
    },
    async getVipRightList() {
      let http = "/coupon/event/list";
      this.loading = true;
      const {data: resData} = await this.$get(http);
      this.loading = false;
      if (resData.data) {
        this.vipRightList = resData.data;
      } else {
        this.vipRightList = [];
      }
    },
    handleTbaClick() {
      this.getRowListInfo()
    },

    async RecommendhandleClick(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `app/exam/recom/info/${row.appExamRecommendId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getRowListInfo();
        this.$message.success("删除成功!");
      });
    },

    async getRowListInfo() {
      const {data: recommendSceneskData} = await this.$get(
          '/app/exam/recom/list?appExamId=' + this.params.appExamId + '&site=' + this.activeName,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (recommendSceneskData.result != 200) return;
      this.recommendSceneskDataList = recommendSceneskData.data;
    },

    async bindRecommend(e, row) {
      this.RecommendclickType = e
      if (e == 'add') {
        this.recommendParams = {};
        this.srcRecommendList = []
        this.isRecommendMoer = true
        this.dialogVisibleRecommendEvaluation = true;
        this.recommendParams.fromAppExamId = this.params.appExamId
      } else if (e == 'edit') {
        //编辑
        const {data: editResData} = await this.$get(
            `app/exam/recom/info/${row.appExamRecommendId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );

        if (editResData.result != 200) return;
        this.srcRecommendList = []
        this.isRecommendMoer = true
        if (editResData.data.recommendImg) {
          this.srcRecommendList.push(editResData.data.recommendImg);
          this.isRecommendMoer = false;
        }
        this.recommendParams = editResData.data;
        this.dialogVisibleRecommendEvaluation = true;
      }
    },

    ParmthandleEdit() {
      if (!this.recommendParams.recommendType) {
        this.$message.error('请选泽类型')
        return
      }
      if (!this.recommendParams.recommendName) {
        this.$message.error('请填写推荐的名称')
        return;
      }
      if (this.recommendParams.recommendType == 'EXAM') {
        if (!this.recommendParams.examId) {
          this.$message.error('请选择测评题')
          return;
        }
      } else {
        this.recommendParams.appExamId = 0
      }
      if (!this.recommendParams.recommendImg) {
        this.$message.error('请上传广告图片')
        return;
      }
      this.recommendParams.recommendSite = this.activeName
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        const {data: resData} = await this.$post(
            "app/exam/recom/info",
            this.recommendParams,
            {
              headers: {
                isLoading: true,
              },
            }
        );

        if (resData.result != 200) return;

        this.dialogVisibleRecommendEvaluation = false;
        this.getRowListInfo()
        this.$message.success("操作成功!");
      });
    },
    getRecommendPolicy() {
      this.$refs.recommendFile.dispatchEvent(new MouseEvent("click"));
    },

    async getRecommendFile() {
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.recommendFile.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.isRecommendMoer = false;
      this.srcRecommendList = addRoutes;
      this.recommendParams.recommendImg = this.srcRecommendList[0];
    },

    changShowTest() {
      if (this.RecommendclickType == 'add') {
        this.alldataSourceVisible = true
      }
    },

    handExamSelectionChange(e) {
      this.recommendParams.bizName = e.name
      this.recommendParams.appExamId = e.appExamId
      this.recommendParams.examId = e.examId
      this.recommendParams.recommendName = e.name
      this.alldataSourceVisible = false
    },
    //获取测评题
    async queryTestTableData() {
      // console.log(this.appInfo.appInfoId)
      // this.app.channelAccountId
      // return
      this.loading = true;
      const {data: resData} = await this.$get("/app/exam/list?appInfoId=" + this.appInfo.appInfoId + "&channelAccountId=" + this.app.channelAccountId + "&paging=false", {
        params: {
          ...this.listParams
        }
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.allTestTableData = resData.data
    },

    getGuoxuePolicyBanner() {
      this.$refs.guoxuefileBanner.dispatchEvent(new MouseEvent("click"));
    },

    async getGuoxueFileBanner() {
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.guoxuefileBanner.files[0],
          resData.data,
          "more", //'more','one'
          this.srcListGuoxueBanner
      );
      this.isMoerBanner = false;
      this.srcListGuoxueBanner = addRoutes;
      this.guoxueParams.banners = this.srcListGuoxueBanner;
    },

    removeGuxueUploading(index) {
      this.srcListGuoxueBanner.splice(index, 1);
      this.guoxueParams.banners = this.srcListGuoxueBanner
    },

    getShowGouxue(e) {
      this.intitleInfoId = e.intitleInfoId
      this.getBabyNameDetails(e.intitleInfoId)
    },

    //获取详情内容
    async getBabyNameDetails(e) {
      this.pageLoading = true;
      this.richTextMouted = false;
      const {data: resData} = await this.$get("/intitle/channel/style/info?intitleInfoId=" + e + '&appInfoId=' + this.appInfo.appInfoId + '&channelAccountId=' + this.app.channelAccountId, {});
      this.pageLoading = false;
      if (resData.result != 200) return;
      let temp = resData.data;
      if (emptyShow(temp.banners)) {
        this.srcListGuoxueBanner = temp.banners; //轮播图
        this.isMoerBanner = true;
      }
      let newarr = JSON.parse(JSON.stringify(temp));
      this.guoxueParams = newarr;
      this.richTextMouted = true;
      this.guoxueDialogVisible = true
    },

    guoxueHandleEdit() {
      // if (!this.guoxueParams.detail) {
      //   this.$message.error('详情内容不能为空')
      //   return;
      // }
      // if (this.guoxueParams.banners.length<=0) {
      //   this.$message.error('轮播图不能为空')
      //   return;
      // }
      this.guoxueParams.appInfoId = this.appInfo.appInfoId
      this.guoxueParams.channelAccountId = this.app.channelAccountId
      this.guoxueParams.intitleInfoId = this.intitleInfoId
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        const {data: resData} = await this.$post(
            "intitle/channel/style/info",
            this.guoxueParams,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.guoxueDialogVisible = false;
        this.$message.success("操作成功!");
      });
    },

    copyLink(e_link) {
      let _this = this
      this.$copyText(e_link).then(function (e) {
        _this.$message.success('复制成功')
      }, function (e) {
        _this.$message.success('复制失败')
      })
    },
    //国学模块
    //获取国学宝宝取名的价格列表
    async getLiteratureList() {
      if (isEmpty(this.getChannel) || isEmpty(this.getNav)) {
        return
      }
      this.loading = true;
      let obj = {
        appInfoId: this.app.appInfoId,
        channelAccountId: this.app.channelAccountId,
        intitleType: this.intitleType
      }
      const {data: resData} = await this.$get("/intitle/price/list", {
        params: {
          ...obj,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        let list = resData.data
        list.forEach((item, index) => {
          item.payPrice = item.payPrice / 100
          item.rawPrice = item.rawPrice / 100
          item.favorable = item.favorable / 100
        })
        this.literatureList = list
      } else {
        this.literatureList = []
      }
    },
    //获取分类列表
    async getLiteratureTypeData() {
      this.loading = true;
      const {data: resData} = await this.$get("intitle/type/list?paging=false");
      this.loading = false;
      if (resData.result != 200) return;
      this.literatureTypelist = resData.data
      this.intitleType = resData.data[0].type
      // this.tarotVisible = true
    },
    // 分类切换
    changLiteratureType(e) {
      this.intitleType = e.type
      this.getLiteratureList()
    },
    //获取分类下的产品
    async getLiteratureData() {
      this.loading = true;
      const {data: resData} = await this.$get("/intitle/info/list?intitleType=" + this.intitleType);
      this.loading = false;
      if (resData.result != 200) return;
      this.literatureData = resData.data
      this.literatureVisible = true
    },
    //多选项
    handleLiteratureSelectionChange(val) {
      this.literatureMultipleSelection = val
    },
    //添加国学内容
    async handleSaveLiterature() {
      if (this.literatureMultipleSelection.length) {
        this.loading = true;
        let arr = []
        this.literatureMultipleSelection.map(item => {
          arr.push(item.intitleInfoId)
        })
        let obj = {
          appInfoId: this.app.appInfoId,
          channelAccountId: this.app.channelAccountId,
          intitleType: this.intitleType,
          intitleInfoIds: arr
        }
        const {data: resData} = await this.$post("/intitle/price/info", {
          ...obj,
        });
        this.loading = false;
        if (resData.result != 200) return;
        this.$message.success(resData.message);
        this.$nextTick(() => {
          setTimeout(() => {
            this.getLiteratureList();
          }, 500);
        });
        this.literatureVisible = false;
      } else {
        this.$message.error('请选择你需要添加的内容');
      }
    },
    //国学内容修改各项值 /好评率。支付。参与数
    async changInfoTagLiterature(e, item) {
      this.loading = true;
      //提交数
      if (e == 1) {
        const {data: resData} = await this.$put(
            `/intitle/price/info/submits/${item.intitlePriceId}/${item.submits}`
        );
        this.loading = false;
        if (resData.result != 200) return;
        this.$message.success("修改成功！");
      }
      //购买数
      if (e == 2) {
        const {data: resData} = await this.$put(
            `/intitle/price/info/buys/${item.intitlePriceId}/${item.buys}`
        );
        this.loading = false;
        if (resData.result != 200) return;
        this.$message.success("修改成功！");
      }
      //支付价
      if (e == 3) {
        let numPay = ((item.payPrice) * 100).toFixed(2)
        const {data: resData} = await this.$put(
            `/intitle/price/info/pay/price/${item.intitlePriceId}/${numPay}`
        );
        this.loading = false;
        if (resData.result != 200) return;
        this.$message.success("修改成功！");
      }
      //原价
      if (e == 4) {
        const {data: resData} = await this.$put(
            `/intitle/price/info/raw/price/${item.intitlePriceId}/${item.rawPrice * 100}`
        );
        this.loading = false;
        if (resData.result != 200) return;
        this.$message.success("修改成功！");
      }
      this.loading = false
    },
    //国学内容修改上下架 推荐
    async changeLiteratureSwitchTab(e, item) {
      this.loading = true
      if (e == 1) {
        const {data: resData} = await this.$put(
            `/intitle/price/info/status/${item.intitlePriceId}`
        );
        this.loading = false;
        if (resData.result != 200) return;
        if (item.status) {
          item.status = 0
        } else {
          item.status = 1
        }
        this.$message.success("修改成功！");
      }
    },
    //塔罗推广链接内容
    async getLiteratureExtensionLink(row) {
      this.dialogVisibleLink = true;
      const {data: linkData} = await this.$get(
          `/intitle/price/info/${row.intitlePriceId}`,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (linkData.result != 200) return;
      this.params = linkData.data;
      const {data: sceneskData} = await this.$get(
          `/intitle/price/info/put/scenes/${row.intitlePriceId}`,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (sceneskData.result != 200) return;
      this.putUpLink = sceneskData.data;
    },
    //塔罗价格列表删除
    async handleLiteratureDelect(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/intitle/price/info/${row.intitlePriceId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getLiteratureList();
        this.$message.success("删除成功!");
      });
    },
    //塔罗的测评选项
    handleselectTarot() {
      this.getTarotTypeData()
    },
    //塔罗分类切换
    changTarotCategoryId(e) {
      this.tarotCategoryId = e.tarotCategoryId
      this.getTarotList()
    },
    //获取塔罗的类型列表
    async getTarotTypeData() {
      this.loading = true;
      const {data: resData} = await this.$get("tarot/type/list?tarotCategoryId=" + this.tarotCategoryId);
      this.loading = false;
      if (resData.result != 200) return;
      this.tarotTypelist = resData.data
      this.tarotVisible = true
    },
    //塔罗多选框
    handleTarotSelectionChange(val) {
      this.tarotMultipleSelection = val
    },
    //添加塔罗的价格数据
    async handleSaveTarot() {
      if (this.tarotMultipleSelection.length) {
        this.loading = true;
        let arr = []
        this.tarotMultipleSelection.map(item => {
          arr.push(item.tarotTypeId)
        })
        let obj = {
          appInfoId: this.app.appInfoId,
          channelAccountId: this.app.channelAccountId,
          tarotCategoryId: this.tarotCategoryId,
          tarotTypeIds: arr
        }
        const {data: resData} = await this.$post("/tarot/price/info", {
          ...obj,
        });
        this.loading = false;
        if (resData.result != 200) return;
        this.$message.success(resData.message);
        this.$nextTick(() => {
          setTimeout(() => {
            this.getTarotList();
          }, 500);
        });
        this.tarotVisible = false;
      } else {
        this.$message.error('请选择你需要添加的内容');
      }
    },
    //获取塔罗分类列表
    async getTarotCategoryList() {
      this.loading = true;
      const {data: resData} = await this.$get("/tarot/category/list?paging=false");
      this.loading = false;
      if (resData.result != 200) return;
      this.tarotCategoryList = resData.data
      this.tarotCategoryId = resData.data[0].tarotCategoryId
    },
    //三种业务切换
    changActive(e) {
      this.businessIndex = e
      if (e == 0) {
        this.queryTableData();
      } else if (e == 1) {
        this.getTarotList()
      } else if (e == 2) {
        this.getLiteratureList()
      }
    },
    //获取塔罗的价格列表
    async getTarotList() {
      if (isEmpty(this.getChannel) || isEmpty(this.getNav)) {
        return
      }
      this.loading = true;
      let obj = {
        appInfoId: this.app.appInfoId,
        channelAccountId: this.app.channelAccountId,
        tarotCategoryId: this.tarotCategoryId
      }
      const {data: resData} = await this.$get("/tarot/price/list", {
        params: {
          ...obj,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        let list = resData.data
        list.forEach((item, index) => {
          item.payPrice = item.payPrice / 100
          item.rawPrice = item.rawPrice / 100
          item.favorable = item.favorable / 100
        })
        this.tarotPriceList = list
      } else {
        this.tarotPriceList = []
      }
    },
    //修改各项值 /好评率。支付。参与数
    async changInfoTag(e, item) {
      this.loading = true;
      //参与数
      if (e == 1) {
        const {data: resData} = await this.$put(
            `/tarot/price/info/submits/${item.tarotPriceId}/${item.submits}`
        );
        this.loading = false;
        if (resData.result != 200) return;
        this.$message.success("修改成功！");
      }
      //购买数
      if (e == 2) {
        const {data: resData} = await this.$put(
            `/tarot/price/info/buys/${item.tarotPriceId}/${item.buys}`
        );
        this.loading = false;
        if (resData.result != 200) return;
        this.$message.success("修改成功！");
      }
      //支付价
      if (e == 3) {
        let numPay = ((item.payPrice) * 100).toFixed(2)
        const {data: resData} = await this.$put(
            `/tarot/price/info/pay/price/${item.tarotPriceId}/${numPay}`
        );
        this.loading = false;
        if (resData.result != 200) return;
        this.$message.success("修改成功！");
      }
      //原价
      if (e == 4) {
        const {data: resData} = await this.$put(
            `/tarot/price/info/raw/price/${item.tarotPriceId}/${item.rawPrice * 100}`
        );
        this.loading = false;
        if (resData.result != 200) return;
        this.$message.success("修改成功！");
      }
      //好评率
      if (e == 5) {
        const {data: resData} = await this.$put(
            `/tarot/price/info/favorable/${item.tarotPriceId}/${item.favorable * 100}`
        );
        this.loading = false;
        if (resData.result != 200) return;
        this.$message.success("修改成功！");
      }
      this.loading = false
    },
    //修改上下架 推荐
    async changeSwitchTab(e, item) {
      this.loading = true
      if (e == 1) {
        const {data: resData} = await this.$put(
            `/tarot/price/info/status/${item.tarotPriceId}`
        );
        this.loading = false;
        if (resData.result != 200) return;
        if (item.status) {
          item.status = 0
        } else {
          item.status = 1
        }
        this.$message.success("修改成功！");
      }
      if (e == 2) {
        const {data: resData} = await this.$put(
            `/tarot/price/info/shows/${item.tarotPriceId}`
        );
        this.loading = false;
        if (resData.result != 200) return;
        if (item.shows) {
          item.shows = 0
        } else {
          item.shows = 1
        }
        this.$message.success("修改成功！");
      }
      this.loading = false
    },
    //塔罗推广链接内容
    async getTarotExtensionLink(row) {
      this.dialogVisibleLink = true;
      const {data: linkData} = await this.$get(
          `/tarot/price/info/${row.tarotPriceId}`,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (linkData.result != 200) return;
      this.params = linkData.data;
      const {data: sceneskData} = await this.$get(
          `/tarot/price/info/put/scenes/${row.tarotPriceId}`,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (sceneskData.result != 200) return;
      this.putUpLink = sceneskData.data;
    },
    //塔罗价格列表删除
    async handleDelect(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/tarot/price/info/${row.tarotPriceId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getTarotList();
        this.$message.success("删除成功!");
      });
    },
    /* 获取该app下已经关联的渠道 */
    async getAreadyChannel(appInfoId) {
      const {data: resData} = await this.$get(
          `/app/channel/list?appInfoId=${appInfoId}`,
          {
            params: {
              status: 1,
              paging: false,
            },
          }
      );
      if (resData.result != 200) return;
      if (!isEmpty(resData.data)) {
        this.getChannel = resData.data;
        this.app.channelAccountId = resData.data[0].channelAccountId;
      }
    },
    /* 所有 导航配置 */
    async getNavList() {
      this.navList = []; //已经关联的id
      const {data: res} = await this.$get("/app/nav/list", {
        params: {
          status: 1,
          paging: false,
        },
      });
      if (!isEmpty(res.data)) {
        this.navList = res.data;
        this.navData(this.$route.query.appInfoId); //需要显示的nav
      }
    },
    /**
     * 获取导航列表
     */
    async navData(appInfoId) {
      this.loading = true;
      this.getNav = [];
      const {data: resData} = await this.$get(
          `/app/unite/nav/ids?appInfoId=${appInfoId}`,
          {
            params: {
              status: 1,
              paging: false,
            },
          }
      );
      this.loading = false;
      if (resData.result != 200) return;
      resData.data.forEach((element) => {
        if (this.navList == []) return;
        this.navList.forEach((ele) => {
          if (!isEmpty(ele)) {
            if (element == ele.appNavId) {
              this.getNav.push(ele);
            }
          }
        });
      });
      if (!isEmpty(this.getNav)) {
        this.app.appNavId = this.getNav[0].appNavId;
      }
    },
    /**
     * 新增测评题
     */
    async addTopicList(app, examInfoIdArr) {
      this.loading = true;
      const {data: resData} = await this.$post("app/exam/info", {
        ...app,
        examInfoIds: examInfoIdArr,
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success(resData.message);
      this.innerVisible = false;
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      if (isEmpty(this.getChannel) || isEmpty(this.getNav)) {
        return
      }
      this.loading = true;

      const {data: resData} = await this.$get("app/exam/list", {
        params: {
          ...this.app,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      let list = resData.data
      list.forEach((item, index) => {
        item.payPrice = item.payPrice / 100
        item.rawPrice = item.rawPrice / 100
      })
      this.tableData = list;
    },
    /**
     * 选择测评题库
     */
    handleselectTopic() {
      localStorage.setItem('channelAccountIds', this.app.channelAccountId)
      localStorage.setItem('appidss', this.appInfo.appInfoId)
      this.innerVisible = true;
    },
    /**
     * 接收选择后的数组
     */
    childByValue(value) {
      // 每次选择都会触发
      this.checkArray = value;
    },
    //确定选择的题列表
    handleTopicList() {
      let temp = [];
      this.checkArray.map((item) => {
        temp.push(item.examInfoId);
      });
      this.examInfoIdArr = temp;
      this.addTopicList(this.app, this.examInfoIdArr);
      this.$nextTick(() => {
        setTimeout(() => {
          this.queryTableData();
        }, 500);
      });
    },
    /**
     * 选择渠道账户 ID
     */
    activeEvent(index, channelAccountId) {
      this.tagIndex = index;
      this.app.channelAccountId = channelAccountId;
      this.tableData = []
      if (this.businessIndex == 0) {
        this.queryTableData();
      } else if (this.businessIndex == 1) {
        this.getTarotList()
      } else if (this.businessIndex == 2) {
        this.getLiteratureList()
      }
      this.queryTestTableData()
    },
    /**
     * 选择导航ID
     */
    activeEventNav(index, appNavId) {
      this.navIndex = index;
      this.app.appNavId = appNavId;
      this.tableData = []
      this.queryTableData();
    },
    /**
     * 刷新发布时间
     */
    async handleClick(type, row = {}) {
      switch (type) {
        case "time":
          this.loading = true;
          const {data: resData} = await this.$put(
              `app/exam/info/issued/time/${row.appExamId}`
          );
          this.loading = false;
          if (resData.result != 200) return;
          this.$message.success("刷新上架时间成功！");
          this.queryTableData(); // 更新列表
          break;
        case "edit":
          this.dialogVisible = true;
          //编辑
          const {data: editResData} = await this.$get(
              `app/exam/info/${row.appExamId}`,
              {
                headers: {
                  isLoading: true,
                },
              }
          );

          if (editResData.result != 200) return;
          this.srcListLang = [];
          this.srcList = [];
          this.srcListBanner = []
          this.isMoer = true;
          this.isMoerLang = true;

          if (editResData.data.logo) {
            this.srcList.push(editResData.data.logo);
            this.isMoer = false;
          }
          if (editResData.data.logo2) {
            this.srcListLang.push(editResData.data.logo2);
            this.isMoerLang = false;
          }
          if (editResData.data.banners) {
            this.srcListBanner = editResData.data.banners;
          }
          this.params.appExamId = row.appExamId;
          this.params = editResData.data;


          this.flag = false;
          this.$nextTick(() => {
            this.flag = true;  //组件生命重新加载
          });

          break;
        case "link":
          this.dialogVisibleLink = true;
          const {data: linkData} = await this.$get(
              `app/exam/info/${row.appExamId}`,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (linkData.result != 200) return;
          this.params = linkData.data;
          const {data: sceneskData} = await this.$get(
              `app/exam/info/put/scenes/${row.appExamId}`,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (sceneskData.result != 200) return;
          this.putUpLink = sceneskData.data;
          break;
        case "recommend":
          this.dialogVisibleRecommend = true;
          const {data: recommendData} = await this.$get(
              `app/exam/info/${row.appExamId}`,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (recommendData.result != 200) return;
          this.params = recommendData.data;
          const {data: recommendSceneskData} = await this.$get(
              '/app/exam/recom/list?appExamId=' + row.appExamId + '&site=' + this.activeName,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (recommendSceneskData.result != 200) return;
          this.recommendSceneskDataList = recommendSceneskData.data;
          break;
        case "del":
          this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
            type: "warning",
          }).then(async () => {
            const {data: resData} = await this.$delete(
                `app/exam/info/${row.appExamId}`,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.queryTableData();
            this.$message.success("删除成功!");
          });
          break;
      }
    },
    /**
     * 修改参与数
     */
    async answeNum(number, appExamId) {
      this.loading = true;
      const {data: resData} = await this.$put(
          `app/exam/info/show/answers/${appExamId}/${number}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success("修改成功！");
    },
    /**
     * 修改购买数
     */
    async buyNum(number, appExamId) {
      this.loading = true;
      const {data: resData} = await this.$put(
          `app/exam/info/show/buys/${appExamId}/${number}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success("修改成功！");
    },
    /**
     * 修改支付价
     */
    async payPrice(number, appExamId) {
      // let number_old = Math.floor(number * 100 ) / 100
      let num = (number * 100).toFixed(2)
      this.loading = true;
      const {data: resData} = await this.$put(
          `app/exam/info/pay/price/${appExamId}/${num}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success("修改成功！");
    },
    /**
     * 修改原价
     */
    async originalPayPrice(number, appExamId) {
      this.loading = true;
      let num = (number * 100).toFixed(2)
      const {data: resData} = await this.$put(
          `app/exam/info/raw/price/${appExamId}/${num}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success("修改成功！");
    },
    /**
     * 修改发布状态
     */
    async changeSwitchIssue(b) {
      const {data: resData} = await this.$put(`app/exam/info/status/${b}`);
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success(resData.message);
    },
    /**
     * 修推荐状态
     */
    async changeSwitchReco(b) {
      const {data: resData} = await this.$put(`app/exam/info/istop/${b}`);
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success(resData.message);
    },
    /**
     * 编辑/新增
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$put(
              "app/exam/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
          );

          if (resData.result != 200) return;

          this.queryTableData();

          this.dialogVisible = false;

          this.$message.success("修改成功!");
        });
      });
    },

    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },

    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.logo = this.srcList[0];
    },

    getPolicyLang() {
      this.$refs.fileLang.dispatchEvent(new MouseEvent("click"));
    },

    async getFileLang() {
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileLang.files[0],
          resData.data,
          "one", //'more','one'
          this.srcListLang
      );
      this.isMoerLang = false;
      this.srcListLang = addRoutes;
      this.params.logo2 = this.srcListLang[0];
    },

    getPolicyVideo() {
      this.$refs.fileVideo.dispatchEvent(new MouseEvent("click"));
    },

    async getFileVideo() {
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileVideo.files[0],
          resData.data,
          "one", //'more','one'
          this.srcListVideo
      );
      this.isMoerVideo = false;
      this.srcListVideo = addRoutes;

      this.params.video = this.srcListVideo[0];
    },

    getPolicyBanner() {
      this.$refs.fileBanner.dispatchEvent(new MouseEvent("click"));
    },

    async getFileBanner() {
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileBanner.files[0],
          resData.data,
          "more", //'more','one'
          this.srcListBanner
      );
      this.isMoerBanner = false;
      this.srcListBanner = addRoutes;
      this.params.banners = this.srcListBanner;
    },

    removeUploading(index) {
      this.srcListBanner.splice(index, 1);
    },


    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.clear_icon_items {
  color: #F56C6C;
  position: absolute;
  left: 14px;
  top: 14px;
}

.clear_icon_items {
  color: #F56C6C;
  position: absolute;
}

.postsdasinfo {
  top: 12px;
  left: 13px;
}

.postsdas {
  top: 12px;
  left: 28px;
}

.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 90%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

.diplay {
  display: inline-block;
}

.screenshot {
  display: inline-block;
  vertical-align: text-top;
}

.video-label {
  margin-right: 15px;
}

.item-add {
  margin: 15px 0;

  .el-button {
    margin-bottom: 15px;
  }

  .el-button img {
    max-height: 12px;
  }
}

.style-outer {
  background: #fff;
  float: left;
  margin: 0 20px 20px 0;
  width: 108px;
  height: 110px;
  border: 1px solid #ddd;
  cursor: pointer;
  position: relative;

  .style__font {
    line-height: 5px;
    margin: 0 0 0 10px;
  }

  .isCheck {
    position: absolute;
    top: 0;
    right: 5px;
    z-index: 2;

    .el-icon-success {
      font-size: 20px;
      color: #ddd;
    }
  }
}

.in_tabs {
  padding: 5px 15px;
  border: 1px solid #b3d8ff;
  margin-right: 5px;
  color: #409eff;
  border-radius: 5px;
  box-sizing: border-box;
  cursor: pointer;
}

.in_tabs:hover {
  background: #b3d8ff;
  color: #ffffff;
}

.active_in_tab {
  background: #b3d8ff;
  color: #ffffff;
}

.in_tabs_car {
  padding: 5px 15px;
  border: 1px solid #fbc4c4;
  margin-right: 5px;
  color: #f56c6c;
  border-radius: 5px;
  box-sizing: border-box;
  cursor: pointer;
}

.in_tabs_car:hover {
  border-color: #fbc4c4;
  background: #fbc4c4;
  color: #ffffff;
}

.active_in_tab_car {
  background: #fbc4c4;
  color: #ffffff;
}
</style>

<style>
.autos .el-tabs__nav-wrap {
  width: 270px !important;
}

.autos .el-tabs__nav {
  width: 100% !important;
}

.autos .el-tabs__item {
  width: 50%;
  padding: 0 !important;
  text-align: center;
  font-weight: 600;
}

.autos .el-tabs__active-bar {
  height: 1px !important;
}

.autos .el-tabs__nav-wrap::after {
  height: 1px !important;
}
</style>

<!--          <el-form-item label="主题" prop="subject">-->
<!--            <el-input-->
<!--                type="textarea"-->
<!--                :autosize="{ minRows: 3, maxRows: 4 }"-->
<!--                placeholder="请填写主题"-->
<!--                v-model="guoxueParams.subject"-->
<!--            >-->
<!--            </el-input>-->
<!--          </el-form-item>-->

<!--          <el-form-item label="数据源">-->
<!--            <span style="margin-right: 15px">题库数据</span>-->
<!--            <el-switch-->
<!--                v-model="guoxueParams.dataStatus"-->
<!--                :active-value="2"-->
<!--                :inactive-value="1"-->
<!--            >-->
<!--            </el-switch>-->
<!--            <span style="margin-left: 15px">本地数据</span>-->
<!--          </el-form-item>-->
<!--          <el-form-item prop="paymentType" label="分类">-->
<!--            {{ guoxueParams.intitleTypeName }}- {{ guoxueParams.intitleType }}-->
<!--          </el-form-item>-->

<!--          <el-form-item label="列表图">-->
<!--            <div class="diplay" style="margin-right: 10px">-->
<!--              <div class="screenshot">-->
<!--                <span-->
<!--                    v-for="(imgUrl, index) in guoxueSrcList"-->
<!--                    :key="index"-->
<!--                    class="slideshow"-->
<!--                >-->
<!--                  <el-image-->
<!--                      style="width: 75px; height: 75px; border-radius: 6px"-->
<!--                      :src="imgUrl"-->
<!--                      fit="cover"-->
<!--                      @click="getGuoxuePolicy"-->
<!--                  />-->
<!--                </span>-->
<!--                <div-->
<!--                    class="up-btn"-->
<!--                    style="width: 75px; height: 75px; line-height: 80px"-->
<!--                    @click="getGuoxuePolicy"-->
<!--                    v-if="isGuoxueMoer"-->
<!--                >-->
<!--                  <i class="el-icon-plus"></i>-->
<!--                </div>-->
<!--              </div>-->
<!--              <input-->
<!--                  type="file"-->
<!--                  ref="guoxuefile"-->
<!--                  @change="getGuoxueFile"-->
<!--                  accept="image/png,image/jpg"-->
<!--              />-->
<!--            </div>-->
<!--            <div class="diplay" style="margin-right: 50px">-->
<!--              <div class="screenshot">-->
<!--                <span-->
<!--                    v-for="(imgUrl, index) in guoxueSrcListLang"-->
<!--                    :key="index"-->
<!--                    class="slideshow"-->
<!--                >-->
<!--                  <el-image-->
<!--                      style="width: 150px; height: 75px; border-radius: 6px"-->
<!--                      :src="imgUrl"-->
<!--                      fit="cover"-->
<!--                      @click="getGuoxuePolicyLang"-->
<!--                  />-->
<!--                </span>-->
<!--                <div-->
<!--                    class="up-btn"-->
<!--                    style="width: 150px; height: 75px; line-height: 80px"-->
<!--                    @click="getGuoxuePolicyLang"-->
<!--                    v-if="isGuoxueMoerLang"-->
<!--                >-->
<!--                  <i class="el-icon-plus"></i>-->
<!--                </div>-->
<!--              </div>-->
<!--              <input-->
<!--                  type="file"-->
<!--                  ref="guoxuefileLang"-->
<!--                  @change="getGuoxueFileLang"-->
<!--                  accept="image/png,image/jpg"-->
<!--              />-->
<!--            </div>-->
<!--            <div class="diplay">-->
<!--              <span class="video-label">视频</span>-->
<!--              <div class="screenshot">-->
<!--                <span-->
<!--                    v-for="(imgUrl, index) in guoxuesrcListVideo"-->
<!--                    :key="index"-->
<!--                    class="slideshow"-->
<!--                >-->
<!--                  <div @click="getguoxuePolicyVideo">-->
<!--                    <video-->
<!--                        width="100%"-->
<!--                        controls="controls"-->
<!--                        style="width: 75px; height: 75px; border-radius: 6px"-->
<!--                    >-->
<!--                      <source :src="guoxuesrcListVideo" type="video/mp4"/>-->
<!--                    </video>-->
<!--                  </div>-->
<!--                </span>-->
<!--                <div-->
<!--                    class="up-btn"-->
<!--                    style="width: 75px; height: 75px; line-height: 80px"-->
<!--                    @click="getguoxuePolicyVideo"-->
<!--                    v-if="isGuoxueMoerVideo"-->
<!--                >-->
<!--                  <i class="el-icon-plus"></i>-->
<!--                </div>-->
<!--              </div>-->
<!--              <input-->
<!--                  type="file"-->
<!--                  ref="guoxuefileVideo"-->
<!--                  @change="getguoxueFileVideo"-->
<!--                  accept="video/*"-->
<!--              />-->
<!--            </div>-->
<!--          </el-form-item>-->
